import * as React from 'react'

const SvgESim = (props) => (
  <svg
    width={26}
    height={30}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect x={2} y={1} width={22} height={28} rx={2} fill='#101AA1' />
    <rect x={4} y={8} width={18} height={14} rx={2} fill='#9B9ECD' />
    <rect x={11} y={3} width={4} height={3} rx={1} fill='#9B9ECD' />
    <rect x={11} y={24} width={4} height={3} rx={1} fill='#9B9ECD' />
    <rect x={4} y={3} width={4} height={3} rx={1} fill='#9B9ECD' />
    <rect x={4} y={24} width={4} height={3} rx={1} fill='#9B9ECD' />
    <rect x={18} y={3} width={4} height={3} rx={1} fill='#9B9ECD' />
    <rect x={18} y={24} width={4} height={3} rx={1} fill='#9B9ECD' />
  </svg>
)

export default SvgESim
